export default "__VITE_ASSET__CqTIL2oD__"